module.exports = __webpack_public_path__ + "img/service-icon6.36117cb2.png";